module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "z-box-wrap"
  }, [_c('ul', {
    staticClass: "head"
  }, [_c('li', {
    class: {
      active: _vm.activeIndex == 0
    },
    on: {
      "click": function($event) {
        _vm.activeIndex = 0
      }
    }
  }, [_vm._v("发布审核" + _vm._s(("(" + (_vm.release.total) + ")")))]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.activeIndex == 1
    },
    on: {
      "click": function($event) {
        _vm.activeIndex = 1
      }
    }
  }, [_vm._v("取消审核" + _vm._s(("(" + (_vm.cancel.total) + ")")))]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.activeIndex == 2
    },
    on: {
      "click": function($event) {
        _vm.activeIndex = 2
      }
    }
  }, [_vm._v("投诉审核" + _vm._s(("(" + (_vm.complain.total) + ")")))])]), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeIndex == 0),
      expression: "activeIndex == 0"
    }],
    staticClass: "tab-div"
  }, [_c('div', {
    staticClass: "search-head"
  }, [_c('span', [_vm._v("状态：")]), _vm._v(" "), _c('el-select', {
    staticClass: "top-choose",
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        _vm.changeType('release')
      }
    },
    model: {
      value: (_vm.release.status),
      callback: function($$v) {
        _vm.$set(_vm.release, "status", $$v)
      },
      expression: "release.status"
    }
  }, _vm._l((_vm.apply.statusOption), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.label
      }
    })
  })), _vm._v(" "), _c('span', [_vm._v("申请时间：")]), _vm._v(" "), _c('el-date-picker', {
    staticClass: "top-choose",
    attrs: {
      "type": "date",
      "placeholder": "选择日期",
      "picker-options": _vm.picker_special
    },
    model: {
      value: (_vm.release.date_start),
      callback: function($$v) {
        _vm.$set(_vm.release, "date_start", $$v)
      },
      expression: "release.date_start"
    }
  }), _vm._v(" "), _c('small', [_vm._v("~")]), _vm._v(" "), _c('el-date-picker', {
    staticClass: "top-choose",
    attrs: {
      "type": "date",
      "placeholder": "选择日期",
      "picker-options": _vm.picker_special
    },
    model: {
      value: (_vm.release.date_end),
      callback: function($$v) {
        _vm.$set(_vm.release, "date_end", $$v)
      },
      expression: "release.date_end"
    }
  }), _vm._v(" "), _c('span', [_vm._v("关键字：")]), _vm._v(" "), _c('el-input', {
    staticClass: "top-choose",
    attrs: {
      "placeholder": "任务编号或名称"
    },
    model: {
      value: (_vm.release.keyStr),
      callback: function($$v) {
        _vm.$set(_vm.release, "keyStr", $$v)
      },
      expression: "release.keyStr"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "front-btn green shift",
    on: {
      "click": function($event) {
        _vm.releaseSearch()
      }
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "list-head",
    style: ({
      'padding-right': _vm.padd_0
    })
  }, [_c('div', [_vm._v("申请时间\n\t\t\t\t\t\t\t"), _c('div', {
    staticClass: "angle-wrap"
  }, [_c('i', {
    staticClass: "el-icon-caret-top",
    class: {
      active: _vm.release.date_sort == 'createdAt_asc'
    },
    on: {
      "click": function () {
        _vm.release.date_sort = 'createdAt_asc';
        _vm.releaseSearch()
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "el-icon-caret-bottom",
    class: {
      active: _vm.release.date_sort == 'createdAt_desc'
    },
    on: {
      "click": function () {
        _vm.release.date_sort = 'createdAt_desc';
        _vm.releaseSearch()
      }
    }
  })])]), _vm._v(" "), _c('div', [_vm._v("发布BU")]), _vm._v(" "), _c('div', [_vm._v("任务编号")]), _vm._v(" "), _c('div', [_vm._v("任务名称")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.release.status != '1'),
      expression: "release.status !='1'"
    }]
  }, [_vm._v("审核人")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.release.status != '1'),
      expression: "release.status !='1'"
    }]
  }, [_vm._v("审核时间")]), _vm._v(" "), _c('div', [_vm._v("状态")]), _vm._v(" "), _c('div', [_vm._v("操作")])]), _vm._v(" "), _c('z-scrollDiv', {
    staticClass: "list-detail"
  }, [_vm._l((_vm.releaseList), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "item"
    }, [_c('div', [_vm._v(_vm._s(_vm._f("placeholder")(item.created_at)))]), _vm._v(" "), _c('div', {
      staticClass: "overhide",
      attrs: {
        "title": item.pub_bu_name
      }
    }, [_vm._v(_vm._s(item.pub_bu_name))]), _vm._v(" "), _c('div', {
      on: {
        "click": function($event) {
          _vm.openDetail(item)
        }
      }
    }, [_vm._v(_vm._s(item.code))]), _vm._v(" "), _c('div', {
      staticClass: "ellipsis",
      attrs: {
        "title": item.task_name
      }
    }, [_vm._v(_vm._s(item.task_name))]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.release.status != '1'),
        expression: "release.status !='1'"
      }],
      staticClass: "overhide",
      attrs: {
        "title": item.real_name
      }
    }, [_vm._v(_vm._s(item.real_name))]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.release.status != '1'),
        expression: "release.status !='1'"
      }]
    }, [_vm._v(_vm._s(item.updated_at))]), _vm._v(" "), _c('div', {
      class: {
        danger: _vm.release.status == '1'
      }
    }, [_vm._v(_vm._s(_vm.statusText(item.status)))]), _vm._v(" "), _c('div', {
      class: {
        'orange-text': item.status == 1
      },
      on: {
        "click": function($event) {
          _vm.showSlider(item, 'release')
        }
      }
    }, [_vm._v(_vm._s(_vm._f("applyStatus")(_vm.release.status)))])])
  }), _vm._v(" "), _c('z-noData', {
    attrs: {
      "list": _vm.releaseList
    }
  })], 2)], 1), _vm._v(" "), _c('z-pagination', {
    staticClass: "inside",
    attrs: {
      "data": _vm.release.data
    },
    on: {
      "getPage": _vm.releaseSearch
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeIndex == 1),
      expression: "activeIndex == 1"
    }],
    staticClass: "tab-div"
  }, [_c('div', {
    staticClass: "search-head"
  }, [_c('span', [_vm._v("状态：")]), _vm._v(" "), _c('el-select', {
    staticClass: "top-choose",
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        _vm.changeType('cancel')
      }
    },
    model: {
      value: (_vm.cancel.status),
      callback: function($$v) {
        _vm.$set(_vm.cancel, "status", $$v)
      },
      expression: "cancel.status"
    }
  }, _vm._l((_vm.apply.statusOption), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.label
      }
    })
  })), _vm._v(" "), _c('span', [_vm._v("申请时间：")]), _vm._v(" "), _c('el-date-picker', {
    staticClass: "top-choose",
    attrs: {
      "type": "date",
      "placeholder": "选择日期",
      "picker-options": _vm.picker_special
    },
    model: {
      value: (_vm.cancel.date_start),
      callback: function($$v) {
        _vm.$set(_vm.cancel, "date_start", $$v)
      },
      expression: "cancel.date_start"
    }
  }), _vm._v(" "), _c('small', [_vm._v("~")]), _vm._v(" "), _c('el-date-picker', {
    staticClass: "top-choose",
    attrs: {
      "type": "date",
      "placeholder": "选择日期",
      "picker-options": _vm.picker_special
    },
    model: {
      value: (_vm.cancel.date_end),
      callback: function($$v) {
        _vm.$set(_vm.cancel, "date_end", $$v)
      },
      expression: "cancel.date_end"
    }
  }), _vm._v(" "), _c('span', [_vm._v("关键字：")]), _vm._v(" "), _c('el-input', {
    staticClass: "top-choose",
    attrs: {
      "placeholder": "任务编号或名称"
    },
    model: {
      value: (_vm.cancel.keyStr),
      callback: function($$v) {
        _vm.$set(_vm.cancel, "keyStr", $$v)
      },
      expression: "cancel.keyStr"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "front-btn green shift",
    on: {
      "click": function($event) {
        _vm.cancelSearch()
      }
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "list-head",
    style: ({
      'padding-right': _vm.padd_1
    })
  }, [_c('div', [_vm._v("申请时间\n\t\t\t\t\t\t\t"), _c('div', {
    staticClass: "angle-wrap"
  }, [_c('i', {
    staticClass: "el-icon-caret-top",
    class: {
      active: _vm.cancel.date_sort == 'createdAt_asc'
    },
    on: {
      "click": function () {
        _vm.cancel.date_sort = 'createdAt_asc';
        _vm.cancelSearch()
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "el-icon-caret-bottom",
    class: {
      active: _vm.cancel.date_sort == 'createdAt_desc'
    },
    on: {
      "click": function () {
        _vm.cancel.date_sort = 'createdAt_desc';
        _vm.cancelSearch()
      }
    }
  })])]), _vm._v(" "), _c('div', [_vm._v("申请BU")]), _vm._v(" "), _c('div', [_vm._v("任务编号")]), _vm._v(" "), _c('div', [_vm._v("任务名称")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cancel.status != '1'),
      expression: "cancel.status !='1'"
    }]
  }, [_vm._v("审核人")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cancel.status != '1'),
      expression: "cancel.status !='1'"
    }]
  }, [_vm._v("审核时间")]), _vm._v(" "), _c('div', [_vm._v("状态")]), _vm._v(" "), _c('div', [_vm._v("操作")])]), _vm._v(" "), _c('z-scrollDiv', {
    staticClass: "list-detail"
  }, [_vm._l((_vm.cancelList), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "item"
    }, [_c('div', [_vm._v(_vm._s(item.created_at))]), _vm._v(" "), _c('div', {
      staticClass: "overhide",
      attrs: {
        "title": item.sub_bu_name
      }
    }, [_vm._v(_vm._s(item.sub_bu_name))]), _vm._v(" "), _c('div', {
      on: {
        "click": function($event) {
          _vm.openDetail(item)
        }
      }
    }, [_vm._v(_vm._s(item.code))]), _vm._v(" "), _c('div', {
      staticClass: "ellipsis",
      attrs: {
        "title": item.task_name
      }
    }, [_vm._v(_vm._s(item.task_name))]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.cancel.status != '1'),
        expression: "cancel.status !='1'"
      }],
      staticClass: "overhide",
      attrs: {
        "title": item.real_name
      }
    }, [_vm._v(_vm._s(item.real_name))]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.cancel.status != '1'),
        expression: "cancel.status !='1'"
      }]
    }, [_vm._v(_vm._s(item.updated_at))]), _vm._v(" "), _c('div', {
      class: {
        danger: _vm.cancel.status == '1'
      }
    }, [_vm._v(_vm._s(_vm.statusText(item.status)))]), _vm._v(" "), _c('div', {
      class: {
        'orange-text': item.status == 1
      },
      on: {
        "click": function($event) {
          _vm.showSlider(item, 'cancel')
        }
      }
    }, [_vm._v(_vm._s(_vm._f("applyStatus")(item.status)))])])
  }), _vm._v(" "), _c('z-noData', {
    attrs: {
      "list": _vm.cancelList
    }
  })], 2)], 1), _vm._v(" "), _c('z-pagination', {
    staticClass: "inside",
    attrs: {
      "data": _vm.cancel.data
    },
    on: {
      "getPage": _vm.cancelSearch
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeIndex == 2),
      expression: "activeIndex == 2"
    }],
    staticClass: "tab-div"
  }, [_c('div', {
    staticClass: "search-head"
  }, [_c('span', [_vm._v("状态：")]), _vm._v(" "), _c('el-select', {
    staticClass: "top-choose",
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        _vm.changeType('complain')
      }
    },
    model: {
      value: (_vm.complain.status),
      callback: function($$v) {
        _vm.$set(_vm.complain, "status", $$v)
      },
      expression: "complain.status"
    }
  }, _vm._l((_vm.apply.statusOption), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.label
      }
    })
  })), _vm._v(" "), _c('span', [_vm._v("申请时间：")]), _vm._v(" "), _c('el-date-picker', {
    staticClass: "top-choose",
    attrs: {
      "type": "date",
      "placeholder": "选择日期",
      "picker-options": _vm.picker_special
    },
    model: {
      value: (_vm.complain.date_start),
      callback: function($$v) {
        _vm.$set(_vm.complain, "date_start", $$v)
      },
      expression: "complain.date_start"
    }
  }), _vm._v(" "), _c('small', [_vm._v("~")]), _vm._v(" "), _c('el-date-picker', {
    staticClass: "top-choose",
    attrs: {
      "type": "date",
      "placeholder": "选择日期",
      "picker-options": _vm.picker_special
    },
    model: {
      value: (_vm.complain.date_end),
      callback: function($$v) {
        _vm.$set(_vm.complain, "date_end", $$v)
      },
      expression: "complain.date_end"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "front-btn green shift",
    on: {
      "click": function($event) {
        _vm.complainSearch()
      }
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "list-head",
    style: ({
      'padding-right': _vm.padd_2
    })
  }, [_c('div', [_vm._v("申请时间\n\t\t\t\t\t\t\t"), _c('div', {
    staticClass: "angle-wrap"
  }, [_c('i', {
    staticClass: "el-icon-caret-top",
    class: {
      active: _vm.complain.date_sort == 'createdAt_asc'
    },
    on: {
      "click": function () {
        _vm.complain.date_sort = 'createdAt_asc';
        _vm.complainSearch()
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "el-icon-caret-bottom",
    class: {
      active: _vm.complain.date_sort == 'createdAt_desc'
    },
    on: {
      "click": function () {
        _vm.complain.date_sort = 'createdAt_desc';
        _vm.complainSearch()
      }
    }
  })])]), _vm._v(" "), _c('div', [_vm._v("投诉BU")]), _vm._v(" "), _c('div', [_vm._v("任务编号")]), _vm._v(" "), _c('div', [_vm._v("任务名称")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.complain.status != '1'),
      expression: "complain.status !='1'"
    }]
  }, [_vm._v("审核人")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.complain.status != '1'),
      expression: "complain.status !='1'"
    }]
  }, [_vm._v("审核时间")]), _vm._v(" "), _c('div', [_vm._v("状态")]), _vm._v(" "), _c('div', [_vm._v("操作")])]), _vm._v(" "), _c('z-scrollDiv', {
    staticClass: "list-detail"
  }, [_vm._l((_vm.complainList), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "item"
    }, [_c('div', [_vm._v(_vm._s(item.created_at))]), _vm._v(" "), _c('div', {
      staticClass: "overhide",
      attrs: {
        "title": item.pub_bu_name
      }
    }, [_vm._v(_vm._s(item.pub_bu_name))]), _vm._v(" "), _c('div', {
      on: {
        "click": function($event) {
          _vm.openDetail(item)
        }
      }
    }, [_vm._v(_vm._s(item.code))]), _vm._v(" "), _c('div', {
      staticClass: "ellipsis",
      attrs: {
        "title": item.task_name
      }
    }, [_vm._v(_vm._s(item.task_name))]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.complain.status != '1'),
        expression: "complain.status !='1'"
      }],
      staticClass: "overhide",
      attrs: {
        "title": item.real_name
      }
    }, [_vm._v(_vm._s(item.real_name))]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.complain.status != '1'),
        expression: "complain.status !='1'"
      }]
    }, [_vm._v(_vm._s(item.updated_at))]), _vm._v(" "), _c('div', {
      class: {
        danger: _vm.complain.status == '1'
      }
    }, [_vm._v(_vm._s(_vm.statusText(item.status)))]), _vm._v(" "), _c('div', {
      class: {
        'orange-text': item.status == 1
      },
      on: {
        "click": function($event) {
          _vm.showSlider(item, 'complain')
        }
      }
    }, [_vm._v(_vm._s(_vm._f("applyStatus")(item.status)))])])
  }), _vm._v(" "), _c('z-noData', {
    attrs: {
      "list": _vm.complainList
    }
  })], 2)], 1), _vm._v(" "), _c('z-pagination', {
    staticClass: "inside",
    attrs: {
      "data": _vm.complain.data
    },
    on: {
      "getPage": _vm.complainSearch
    }
  })], 1)]), _vm._v(" "), _c('sliderPage', {
    attrs: {
      "title": _vm.slider_title,
      "sliderArg": _vm.sliderArg
    },
    on: {
      "close": _vm.sliderClear
    }
  }, [(_vm.activeIndex == 0) ? _c('sliderRelease', {
    attrs: {
      "sliderArg": _vm.sliderArg,
      "data": _vm.slider_data,
      "examine": _vm.sub
    }
  }) : _vm._e(), _vm._v(" "), (_vm.activeIndex == 1) ? _c('sliderCancel', {
    attrs: {
      "sliderArg": _vm.sliderArg,
      "data": _vm.slider_data,
      "examine": _vm.sub
    }
  }) : _vm._e(), _vm._v(" "), (_vm.activeIndex == 2) ? _c('sliderComplain', {
    attrs: {
      "sliderArg": _vm.sliderArg,
      "data": _vm.slider_data,
      "examine": _vm.sub
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-tip",
    attrs: {
      "slot": "pass"
    },
    slot: "pass"
  }, [_c('div', {
    staticClass: "text"
  }, [_vm._v("是否确认提交处理结果")]), _vm._v(" "), _c('div', {
    staticClass: "btns"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.sliderArg.insideFlag = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeIndex == 0),
      expression: "activeIndex == 0"
    }],
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.confirmRealease(_vm.slider_data.id)
      }
    }
  }, [_vm._v("确定")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeIndex == 1),
      expression: "activeIndex == 1"
    }],
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.confirmCancel(_vm.slider_data.id)
      }
    }
  }, [_vm._v("确定")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeIndex == 2),
      expression: "activeIndex == 2"
    }],
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.confirmComplain(_vm.slider_data.id)
      }
    }
  }, [_vm._v("确定")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-tip",
    attrs: {
      "slot": "notpass"
    },
    slot: "notpass"
  }, [_c('div', {
    staticClass: "text"
  }, [_vm._v("是否确认提交处理结果")]), _vm._v(" "), _c('div', {
    staticClass: "btns"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.sliderArg.insideFlag = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeIndex == 0),
      expression: "activeIndex == 0"
    }],
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.refuseRealease(_vm.slider_data.id)
      }
    }
  }, [_vm._v("确定")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeIndex == 1),
      expression: "activeIndex == 1"
    }],
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.refuseCancel(_vm.slider_data.id)
      }
    }
  }, [_vm._v("确定")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeIndex == 2),
      expression: "activeIndex == 2"
    }],
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.refuseComplain(_vm.slider_data.id)
      }
    }
  }, [_vm._v("确定")])], 1)])], 1), _vm._v(" "), _c('z-windowPop', {
    attrs: {
      "show": _vm.pop.show,
      "height": '80%',
      "noBtns": true,
      "title": ("任务编号：" + (_vm.pop.title)),
      "black": true
    },
    on: {
      "cancel": function($event) {
        _vm.pop.show = false
      }
    }
  }, [_c('readDetail', {
    attrs: {
      "taskId": _vm.pop.id
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-1d78f674!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/frontStage/examine/page-task-examine.vue
// module id = 704
// module chunks = 1